import * as React from 'react';
import { NoSearchResults } from './NoSearchResults';
import { useSearchHeader } from '@src/contexts/SearchHeaderContext';

interface NoSearchResultsBlockProps {
  settings?: {
    title?: string;
    message?: string;
    suggestions_title?: string;
    suggestions_list?: string;
    cta_text?: string;
    cta_link?: string;
    text_alignment?: 'left' | 'center' | 'right';
    background_color?: string;
    custom_css_class?: string;
    [key: string]: any;
  };
  className?: string;
}

export const NoSearchResultsBlock: React.FC<NoSearchResultsBlockProps> = ({ settings, className = '' }) => {
  const blockSettings = settings?.settings?.block_settings || settings || {};

  return (
    <div className={`w-full ${className}`}>
      <NoSearchResults
        title={blockSettings.title}
        message={blockSettings.message}
        suggestions_title={blockSettings.suggestions_title}
        suggestions_list={blockSettings.suggestions_list}
        cta_text={blockSettings.cta_text}
        cta_link={blockSettings.cta_link}
        text_alignment={blockSettings.text_alignment}
        background_color={blockSettings.background_color}
        custom_css_class={blockSettings.custom_css_class}
        settings={blockSettings}
      />
    </div>
  );
};
